import type { UUID } from '@cobliteam/common-types';

export enum ExpenseType {
  FIXED = 'FIXED',
  VARIABLE = 'VARIABLE',
  INDIRECT = 'INDIRECT',
}

export interface CreateExpenseRequest {
  occurredAt: string;
  vehicleId: UUID;
  groupPath: string;
  categoryId: UUID;
  type: string;
  totalCost: number;
  supplierId?: UUID;
  observation?: string;
}

export interface UpdateExpenseRequest {
  occurredAt: string;
  vehicleId: UUID;
  groupPath: string;
  categoryId: UUID;
  type: string;
  totalCost: number;
  supplierId?: UUID;
  observation?: string;
}

export interface ReportExpenseRequest {
  destinationEmails: string[];
  searchQuery?: string;
  types?: string[];
  categoryIds?: UUID[];
  vehicleIds?: UUID[];
  vehicleGroupIds?: string[];
  vehicleSizes?: string[];
  tagNames?: string[];
  sortField?: string;
  sortDirection?: 'ASC' | 'DESC';
  startDate: string;
  endDate: string;
}

export interface ReportVehicleExpenseRequest {
  startDate: string;
  endDate: string;
  destinationEmails: string[];
  searchQuery?: string;
  vehicleIds?: UUID[];
  vehicleGroupIds?: string[];
  vehicleSizes?: string[];
  tagNames?: string[];
  sortField?: string;
  sortDirection?: 'ASC' | 'DESC';
}
